<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4">
          <!-- Progress -->
          <div class="progress">
            <div class="progress-bar" role="progressbar" style="width: 77%"
              aria-valuenow="77" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <p v-html="data.verification.confirmNumberText"></p>
          <div class="input-wrapper">
            <PincodeInput
              v-model="phoneCode"
              :autofocus="true"
              :length="codeLength"
              placeholder=""
            />
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block"
            :disabled="!isCodeLengthValid"
            @click="codeEntered()"
            v-html="data.verification.confirmNumberBtn">
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-sm btn-primary btn-block"
            @click="goBack()" v-html="data.misc.goBackBtn"></button>
          <div class="clearfix--min"></div>
          <alert class="alert alert-danger" v-show="alert"><span v-html="data.error.errorText"></span></alert>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm"></div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '../../src/components/Alert'
import PincodeInput from 'vue-pincode-input'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import { showDelayText } from '../plugins/delayhandler'

export default {
  name: 'entercode',
  components: {
    Alert,
    PincodeInput
  },
  data () {
    return {
      data: null,
      alert: false,
      phoneCode: '',
      codeLength: 6,
      language: sessionStorage.getItem('language')
    }
  },
  computed: {
    isCodeLengthValid () {
      return this.phoneCode.length === this.codeLength
    }
  },
  methods: {
    goBack () {
      setTimeout(() => { window.scrollTo(0, 0) })
      this.$router.go(-1)
    },
    enterKeyHandler (e) {
      if (e.key === 'Enter' && this.isCodeLengthValid) {
        this.codeEntered()
      }
    },
    codeEntered () {
      this.alert = false
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      const phoneNumber = sessionStorage.getItem('nmbr')
      axios.postVerifyPhone(config.verifyPhoneCheckUri, phoneNumber, this.phoneCode).then((response) => {
        if (response.status === 200) {
          loader.hide()
          sessionStorage.removeItem('nmbr')
          this.$router.push('/nextstep')
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          this.alert = true
        }
      })
    }
  },
  created () {
    window.addEventListener('keydown', this.enterKeyHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.enterKeyHandler)
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          verification(locale: ` + sessionStorage.getItem('language') + `) {
            confirmNumberText
            confirmNumberBtn
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            errorText
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            goBackBtn
          }
        }
      `
    })
    setTimeout(() => { window.scrollTo(0, 0) })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding-bottom: 6vh;
}
.input-wrapper {
  margin-bottom: 2vh;
}
.alert {
  padding: 1rem 0.5rem 0 1.6rem !important;
  font-size: 0.7em !important;
}
button:disabled {
  opacity: 0.3;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
  div.vue-pincode-input-wrapper {
    background: #00196529;
    padding: 10px;
    border-radius: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EnterCode.vue